<template>
	<div class="add-edit-dialog">
		<el-dialog
		  :title="oc_id > 0 ? '编辑渠道' : '添加渠道'"
		  :visible.sync="show"
		  :before-close="_close"
		  :close-on-click-modal="false"
		>
			<el-row>
				<el-col>
					<el-form class="myform" :model="formData" :rules="formRule" ref="ruleForm" label-width="110px">
			
						<el-form-item label="渠道名称" prop="name">
							<div class="form-item">
								<el-input class="bill_input" v-model="formData.name" placeholder="输入渠道名称" maxlength="25">
								</el-input>
							</div>
						</el-form-item>
			
						<el-form-item label="联系人" prop="linkman">
							<div class="form-item">
								<el-input class="bill_input" v-model="formData.linkman" placeholder="输入联系人名称" maxlength="10">
								</el-input>
							</div>
						</el-form-item>
						
						<el-form-item label="联系电话" prop="phone">
							<div class="form-item">
								<el-input class="bill_input" v-model="formData.phone" placeholder="输入联系电话" maxlength="11" :disabled="oc_id > 0 ? true : false">
								</el-input>
							</div>
						</el-form-item>
						
						<el-form-item label="地区选择" prop="region">
							<div class="form-item">
								<el-cascader class="bill_input" v-model="formData.region" :options="options" @change="handleChange" placeholder="省/市/区"></el-cascader>
							</div>
						</el-form-item>
						
						<el-form-item label="详细地址" prop="address">
							<div class="form-item">
								<el-input class="bill_input" type="textarea" v-model="formData.address" placeholder="输入详细地址"
									maxlength="120" show-word-limit>
								</el-input>
							</div>
						</el-form-item>
						
						<el-form-item label="分润比例" prop="def_rate">
							<div class="form-item">
								<el-input class="bill_input" v-model="formData.def_rate" placeholder="需填写0-50区间的数值" @input="_inputChange($event)">
								<template slot="append">%</template>
								</el-input>
							</div>
						</el-form-item>
			
						<div class="form-handle">
							<el-button type="infor" @click="_close()">取消</el-button>
							<el-button type="primary" @click="_save('ruleForm')" :loading="submiting">确定</el-button>
						</div>
					</el-form>
				</el-col>
			</el-row>
		
		</el-dialog>
	</div>
</template>

<script>
	import {
		addOrEdit,
		basicInfo,
	} from '@/api/channel';
	import area from '@/assets/js/area.js';
	
	export default {
		data() {
			return {
				options: area,
				submiting: false,
				formData: {
					name: '',
					linkman: '',
					phone: '',
					region: '',
					address: '',
					def_rate: ''
				},
				formRule: {
					name: [{
						required: true,
						message: '请输入渠道名称'
					}],
					linkman: [{
						required: true,
						message: '请输入联系人名称'
					}],
					phone: [{
						required: true,
						message: '请输入联系电话',
					}],
					region: [{
						type:'array', 
						required: true, 
						message: "请选择地区", 
						trigger: "change"
					}],
					address: [{
						required: true,
						message: '请输入详细地址',
					}],
					def_rate: [{
						required: true,
						message: '请输入分润比例',
					}]
				},
			};
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			oc_id: {
				type: Number,
				default: 0,
			},
		},
		watch:{
			show: function(){
				if(this.oc_id > 0){
					this._getInfo();
				}else{
					this.formData.channel_id = 0;
				}
			}
		},
		methods: {
			// 省市区联动
			handleChange(e){
				console.log(e)
			},
			_close() {
				this._clear();
				this.$emit('close');
			},
			_clear(){
				this.submiting = false;
				this.$refs['ruleForm'].resetFields();
			},
			_inputChange(event) {
				var value = '' + event;
				value = value.replace(/\s/g, "");
				value = num(value);
				this.formData['def_rate'] = value;
			},
			_save(){
				var that = this;
				
				if (that.formData.def_rate < 0 || that.formData.def_rate > 50) {
					this.$message.error("分润比例需设置在0~50%之间");
					return false;
				}
				
				var info = that.formData;
				if (this.submiting) {
					return false;
				}
				
				that.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						info.oc_id = that.oc_id;
						
						// 处理地区数据 START
						if(info.region.length == 2){
							info.province = '';
							info.city = info.region[0];
							info.county = info.region[1];
						}else if(info.region.length == 1){
							info.province = info.region[0];
							info.city = '';
							info.county = '';
						}else{
							info.province = info.region[0];
							info.city = info.region[1];
							info.county = info.region[2];
						}
						// 处理地区数据 END
						
						that.submiting = true; 
						addOrEdit(info).then(res => {
							if (res.code == 0) {
								that._clear();
								that.$emit('success');
							}else{
								that.$message.error(res.message);
								that.submiting = false;
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 编辑获取数据
			_getInfo() {
				basicInfo({
					oc_id: this.oc_id
				}).then(res => {
					if (res.code == 0) {
						this.formData = res.data;
					} else {
						this.$message.error(res.message);
					}
				})
			},
		},
		mounted() {
		}
	}
	function num(value) {
		value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
		value = value.replace(/^\./g, ""); //验证第一个字符是数字
		value = value.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
		value = value.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
		value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
		var smPric = /^\d{0,10}(\.\d{0,2})?$/;
		
		if (!smPric.test(value)) {
			return '';
		}
		return value;
	}
	
</script>

<style>
	.add-edit-dialog .el-dialog__body {
		padding-top: 0;
		padding-bottom: 16px;
		height: 500px;
		overflow-x: auto;
		font-size: 14px;
	}
	.add-edit-dialog .el-dialog {
		width: 500px;
	}
	.add-edit-dialog .el-row{
		margin-top: 20px;
	}
	.add-edit-dialog .el-form-item__error{
		left: 20px;
	}
	
	.add-edit-dialog .el-form-item__label{
		font-weight: bold;
		margin-right: 20px;
	}
	.add-edit-dialog .bill_input{
		width: 284px;
	}
	.add-edit-dialog .form-handle{
		text-align: right;
		margin-top: 30px;
	}
	.add-edit-dialog .form-handle button{
		width: 80px;
	}
	.add-edit-dialog .el-textarea__inner{
		height: 77px;
	}
</style>